var chopstickNavigation = function() {

    var _nav = $('.js-nav'),
        _overlay = $('.js-frame-overlay'),
        _trigger = $('.js-nav-trigger');

    function toggleNavigation() {
        // toggle overlay
        _overlay.toggleClass('is-visible');

        // toggle trigger style
        _trigger.toggleClass('is-toggled');

        // toggle navigation
        _nav.toggleClass('is-visible');
    }

    // Bind click event to tab items
    _trigger.on('click', function(e){
        // Prevent the default action on links
        e.preventDefault();

        // Switch tab to active
        toggleNavigation();
    });
};
